import React from "react";
import exploreMotionIcon from "../../../utilities/images/study_dashboard/explore_motion_icon.png";
import "./ExploreMotionButton.css";

const ExploreMotionButton = ({ onClick }) => {
  return (
    <button type="button" className="explore-motion-btn" onClick={onClick}>
      <img
        src={exploreMotionIcon}
        alt=""
        className="explore-motion-btn__icon"
        width={24}
        height={24}
        aria-hidden="true"
      />
      <span className="explore-motion-btn__label">Explore Store</span>
    </button>
  );
};

export default ExploreMotionButton;
